import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Barrio } from "../../../../shared/types/barrio";

export interface BarrioAddRequest {
    nombre: string,
    codigo: string,
    ciudadId: string,
}

export async function addBarrio(request: BarrioAddRequest) : Promise<Barrio> {
    await sleep(1000);
    const response = await api.post("barrios", request);
    return response.data;
}

export function useAddBarrioMutation(mutationConfig: MutationConfig<Barrio, BarrioAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addBarrio,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["barrios"] });
        },
    })
}

export interface AddBarrioMutationProps{
    mutationConfig?: MutationConfig
    children?: (mutationResult: MutationResult<Barrio, BarrioAddRequest>) => ReactNode
}

export function AddBarrioMutation({
    mutationConfig,
    children
}: AddBarrioMutationProps) {
    const mutationResult = useAddBarrioMutation(mutationConfig);
    return children && children(mutationResult);
}

